import type { NumbersItem, TextItem, ModuleNumbersMode, ModuleTextMode } from '../../types';
import APP_ID from './environment';

export const APP_NAME = APP_ID.replace('oneaudi-feature-app-', '').replace(/-/g, ' ');

enum NumberOfComponents {
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
}

const getNumberOfComponentsPerRow: { [index: string]: number } = {
  [NumberOfComponents.TWO]: 2,
  [NumberOfComponents.THREE]: 3,
  [NumberOfComponents.FOUR]: 2,
  [NumberOfComponents.FIVE]: 3,
  [NumberOfComponents.SIX]: 3,
  [NumberOfComponents.SEVEN]: 3,
  [NumberOfComponents.EIGHT]: 2,
  [NumberOfComponents.NINE]: 3,
};

export const groupComponents = ({ components }: ModuleTextMode | ModuleNumbersMode) => {
  if (!components) return null;
  const offset = getNumberOfComponentsPerRow[components.length];
  let count = 0;
  const final: (TextItem[] | NumbersItem[])[] = [];
  let tempArray: (TextItem | NumbersItem)[] = [];

  components.forEach((comp) => {
    if (count < offset) {
      tempArray.push(comp);
      count += 1;
    } else {
      count = 1;
      final.push(tempArray);
      tempArray = [comp];
    }
  });
  final.push(tempArray);

  return final;
};

export const FA_LOCATOR_ID = `fa-editorial-colmuns`;

export const FA_LOCATOR = `[data-test-id=${FA_LOCATOR_ID}]`;

export function getInstanceIndexNo(ref: React.MutableRefObject<null>): number {
  const quoteElements = document.querySelectorAll(FA_LOCATOR);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < quoteElements.length; i++) {
    if (quoteElements[i] === ref.current) {
      return i;
    }
  }

  return 0;
}
